import { AddBasicInfoComponent } from './add_basicinfo.component';
import { BasicInfoAuthenticatedComponent } from './basicInfo_authenticated.component';
import { BasicInfoGuestComponent } from './basicInfo_guest.component';
import { ValidPhoneNumberDirective } from './valid_phone_number.directive';

import { BasicInfoService } from './basicInfo.service';

export const BasicInfoModule = angular.module('oo.checkout.basicInfo', [])
    .component('basicInfoAuthenticated', BasicInfoAuthenticatedComponent)
    .component('basicInfoGuest', BasicInfoGuestComponent)
    .component('addBasicInfo', AddBasicInfoComponent)

    .directive('validPhoneNumber', ValidPhoneNumberDirective)
    .service('basicInfoService', BasicInfoService)
    .name;
